<template>

    <el-dialog title="发送工作流" :visible.sync="visible" @close="close">
        <el-form ref="workflowForm" :model="workflowForm" label-width="100px">
            <el-row>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="当前节点">
                        <el-input v-model="currentNodeName" size="small" :disabled="true"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="下一节点" required="true">
                        <el-select v-model="workflowForm.nextNodeId" placeholder="请选择下一节点" size="small"
                                   class="width100" @change="changeNodeId">
                            <el-option
                                    v-for="item in nodes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <el-form-item label="备注">
                        <el-input maxlength="256" type="textarea" v-model="workflowForm.remark"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <slot name="customInfo"></slot>

            <el-row>
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <el-form-item label="附件（流转信息）" label-width="155px">
                        <el-upload
                                ref='upload'
                                class="upload-demo"
                                :action="''"
                                :http-request="uploadFileFunc"
                                :before-upload="beforeAvatarUpload"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                            <el-button size="small" type="primary">添加附件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelFunc">取 消</el-button>
            <el-button type="primary" @click="confirmFunc" :disabled="disabldButton">确 定</el-button>
        </div>

    </el-dialog>

</template>


<script>

    function getStatus(node, statusName) {
      let status = 'DRAFT';
      let setValueObj = null;
      if (node._setValueObj != null) {
        setValueObj = node._setValueObj;
      } else if (node.setValue != null && node.setValue !== '') {
        setValueObj = JSON.parse(node.setValue);
      }
      node._setValueObj = setValueObj;
      if (setValueObj != null) {
        if (node.id != null && node.id < 0 || node.currentNodeId != null && node.currentNodeId <= 0) {
          // 系统自定义节点
          if (setValueObj['athubStatus'] != null) {
            status = setValueObj['athubStatus']
          }
        } else {
          status = setValueObj[statusName];
        }
      }
      return status;
    }

    export default {

        name: 'workflow_dialog',

        data() {
            return {
                disabldButton:false,
                workflowForm: {
                    nextNodeId: '',
                    currentStatus: '',
                    nextStatus: '',
                    remark: '',
                    token: '',
                    setValue: null,
                },
                currentNodeName: '',
                currentNodeId:null,
                nodes: [],
                visible: this.dialogWorkflowVisible,

                uploadFile: '',
                isAllow2Upload: true,
                fileList: [],
            }
        },

        props: ['dialogWorkflowVisible', 'bussinessId', 'bussiness', 'workflowRequestInfo', 'statusName'],

        watch: {

            dialogWorkflowVisible: {
                handler: function (newVal, oldVal) {
                    this.visible = newVal;
                }
            },

            workflowRequestInfo: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    if (newVal == null || newVal.nodeInfo == null) {
                        return;
                    }

                    this.nodes = [];
                    for (let i = 0; i < newVal.nodeInfo.nextNodes.length; i++) {
                      let node = newVal.nodeInfo.nextNodes[i];
                      let nodeModel = {
                        value: node.id + '',
                        label: node.name,
                      };
                      if (node.setValue == null || node.setValue === '') {
                        nodeModel.status = '';
                      } else {
                        let setValue = JSON.parse(node.setValue);
                        nodeModel.setValue = setValue;
                        nodeModel.status = setValue[this.statusName];
                      }
                      this.nodes.push(nodeModel);
                      /*  this.nodes.push({
                            value: newVal.nodeInfo.nextNodes[i].id + '',
                            label: newVal.nodeInfo.nextNodes[i].name,
                            //事件待审核获取下一节点信息得时候，返回得撤销setValue=""
                            status: newVal.nodeInfo.nextNodes[i].setValue==''?'':JSON.parse(newVal.nodeInfo.nextNodes[i].setValue)[this.statusName],
                        })*/
                    }
                    this.workflowForm.currentStatus = getStatus(newVal.nodeInfo, this.statusName);
                    // this.workflowForm.nextStatus = setValue[this.statusName];
                    this.workflowForm.setValue = newVal.nodeInfo._setValueObj;
                    this.workflowForm.nextNodeId = newVal.nodeInfo.nextDefault + '';
                    this.currentNodeName = newVal.nodeInfo.nodeName;
                    this.currentNodeId=newVal.nodeInfo.currentNodeId;
                    this.changeNodeId();

                }
            }
        },

        methods: {

            init() {
                this.currentNodeName = '';
                this.nodes = [];
                this.uploadFile = '';
                this.workflowForm.remark = '';
                this.workflowForm.nextStatus = '';
                this.workflowForm.setValue = null;
                this.$refs.upload.clearFiles();
            },

            cancelFunc() {
                this.close();
            },

            confirmFunc() {

                if (this.bussinessId == '' || this.bussinessId == -1) {
                    this.$message.error('请先保存基本信息');
                    return;
                }

                //防止重复提交
                this.disabldButton=true;
                var nextNodeName;
                for(var i=0;i<this.nodes.length;i++){
                    if(this.workflowForm.nextNodeId==this.nodes[i].value){
                        nextNodeName=this.nodes[i].label;
                    }
                }

                let bussinessInfo = {
                    bussiness: this.bussiness,
                    bussinessId: this.bussinessId,
                    nextNodeId: this.workflowForm.nextNodeId,
                    previousNodeId:this.currentNodeId,
                    currentStatus: this.workflowForm.currentStatus,
                    nextStatus: this.workflowForm.nextStatus,
                    wfToken: this.workflowRequestInfo.wfToken,
                    remark: this.workflowForm.remark,
                    afile: this.uploadFile,
                    params: this.workflowRequestInfo.params,
                    nextNodeName: nextNodeName,
                    ownerId: this.workflowRequestInfo.ownerId,
                    setValue: this.workflowForm.setValue == null || this.workflowForm.setValue === '' ? null :
                        JSON.stringify(this.workflowForm.setValue),
                };

                // this.init();

                this.$emit('afterAuditWorkflowFunc', bussinessInfo);

                // this.close();
            },

            changeNodeId() {
                let node = this.nodes.filter(e => {
                    return e.value == this.workflowForm.nextNodeId;
                })
                if (node.length == 0) {     //默认下一节点在可选nodes中不存在的话，默认为空，需要手动选择
                    this.workflowForm.nextNodeId = '';
                    this.workflowForm.nextStatus = '';
                    this.workflowForm.setValue = null;
                } else {
                    this.workflowForm.nextStatus = node[0].status;
                    this.workflowForm.setValue = node[0].setValue;
                }

                if(this.currentNodeName=='审批'||this.currentNodeName=='重新审批'){
                    this.$emit('elSelectChangeEvent', node[0].label);
                }

            },

            close() {
                this.init();
                //防止重复提交
                this.disabldButton=false;
                this.$emit('update:dialogWorkflowVisible', false);
            },

            handleRemove(file, fileList) {
                this.uploadFile = '';
            },

            beforeRemove(file, fileList) {
                if (this.isAllow2Upload) {
                    return this.$confirm(`确定移除 ${file.name}？`);
                }
            },

            handleExceed(files, fileList) {
                // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                this.$message.warning(`当前限制选择一个文件，请删除选择的文件再添加`);
            },

            uploadFileFunc(params) {
                this.uploadFile = params.file;
            },

            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传附件大小不能超过 2MB!');
                    this.isAllow2Upload = false;
                }
                return isLt2M;
            },

        },

    }
</script>
